import React from 'react';
import "../articleDetailsWrapper/articleDetails.scss";

function TermAndCondition({ data }) {
  return (
    <div className='share-content'>{data?.text}<br/>{data?.text2}</div>
  )
}

export default TermAndCondition